import React, { useCallback } from 'react';
import { IOnSubmitArgs, OpForm } from "components/customAntd/DLS/OpForm/OpForm";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { notification } from 'antd';
import { describeUser } from 'store/slices/usersSlice';
import { useTranslation } from 'react-i18next';
import { patchRequest } from 'api/apiClient';

interface InfoContentProps {
    form: any;
    onClose: () => void;
}

const InfoContent: React.FC<InfoContentProps> = ({ form, onClose }) => {
    const dispatch: AppDispatch = useDispatch();
    const { t } = useTranslation();

    const orgId = useSelector((state: RootState) => state.globalOrg.globalOrgId);
    const { globalUser } = useSelector((state: RootState) => state.users);
    const initialValues = {
        identity: {
            email: globalUser?.identity?.email,
            firstName: globalUser?.identity?.firstName,
            middleName: globalUser?.identity?.middleName,
            lastName: globalUser?.identity?.lastName,
        }
    };


    const handleSubmit = useCallback(async ({ values }: IOnSubmitArgs<any>) => {
        if (!globalUser?.id) return;

        if (!!globalUser?.masterIntegrationId) {
            notification.error({
                message: t('notification.error'),
                description: t('profile.notification.editErrorExternalSystem'),
                placement: 'bottomRight',
            });
            return;
        }

        try {
            await patchRequest(`/orgs/${orgId}/profile`,
                {
                    firstName: values.identity.firstName,
                    middleName: values.identity.middleName,
                    lastName: values.identity.lastName,
                }
            );

            dispatch(describeUser({ orgId, userId: globalUser.id, global: true }));

            notification.success({
                message: t('notification.success'),
                description: t('profile.info.success'),
                placement: 'bottomRight',
            });

            onClose();
        } catch (error) {
            notification.error({
                message: t('notification.error'),
                description: t('profile.info.error'),
                placement: 'bottomRight',
            });
            console.error(error);
        }
    }, [orgId, globalUser?.id, globalUser?.masterIntegrationId, onClose, dispatch, t]);

    return (
        <OpForm
            form={form}
            initialValues={initialValues}
            onSubmit={handleSubmit}
            hasError={false}
            disabled={!!globalUser?.masterIntegrationId}
        >
            <OpForm.Input
                label={t('profile.info.email')}
                name={['identity', 'email']}
                rules={[{ required: true, message: t('profile.info.emailRequired'), type: 'email' }]}
                disabled
            />
            <OpForm.Input
                label={t('profile.info.firstName')}
                name={['identity', 'firstName']}
                rules={[{ required: true, message: t('profile.info.firstNameRequired') }]}
            />
            <OpForm.Input
                label={t('profile.info.middleName')}
                name={['identity', 'middleName']}
            />
            <OpForm.Input
                label={t('profile.info.lastName')}
                name={['identity', 'lastName']}
            />
        </OpForm>
    );
};

export default InfoContent;
